export const CREDIT_700_CTA_TITLE = 'Get Pre-Qualified Now!';
export const CREDIT_700_CTA_TYPE = 'url700Credit';
